export const API_SERVER = process.env.NEXT_PUBLIC_API_URL_ADMIN
export const LOCAL_API_SERVER = process.env.NEXT_PUBLIC_APP_API
export const URL_SERVER = process.env.NEXT_PUBLIC_APP_URL
export const TOKEN_KEY = process.env.NEXT_PUBLIC_TOKEN_KEY
export const URL_IMAGE = process.env.NEXT_PUBLIC_URL_IMAGE
export const FACEBOOK_APP_ID = process.env.FACEBOOK_APP_ID
